import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslocoDirective } from "@jsverse/transloco";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { RadioButtonModule } from "primeng/radiobutton";

interface RadioOption {
  label: string;
  value: string;
  disabled?: boolean;
}

/* 
  Example usage:
  {
    key: "preferredContact",
    type: "radio",
    props: {
      label: {
        en: "Preffered contact method",
        fi: "Toivottu yhteydenottotapa",
        sv: "Önskad kontaktmetod",
      },                                              // Optional
      description: {
        en: "How would you like to be contacted?",
        fi: "Miten haluat tulla kontaktoiduksi?",
        sv: "Hur vill du bli kontaktad?",
      },                                              // Optional
      required: true,
      options: [
        {
          label: {
            en: "Email",
            fi: "Sähköposti",
            sv: "E-post",
          },
          value: 'email',
        },
        {
          label: {
            en: "Phone",
            fi: "Puhelin",
            sv: "Telefon",
          },
          value: 'phone',
        },
        {
          label: {
            en: "SMS",
            fi: "Tekstiviesti",
            sv: "SMS",
          },
          value: 'sms',
          disabled: true,                             // Optional: Disable this option
        },
      ]
    }
  }


  ////////////////////

  JSON example:

  {
    "key": "preferredContact",
    "type": "radio",
    "props": {
      "label": {
        "en": "Preferred contact method",
        "fi": "Toivottu yhteydenottotapa",
        "sv": "Önskad kontaktmetod"
      },                                              // Optional
      "description": {
        "en": "How would you like to be contacted?",
        "fi": "Miten haluat tulla kontaktoiduksi?",
        "sv": "Hur vill du bli kontaktad?"
      },                                              // Optional
      "required": true,
      "options": [
        {
          "label": {
            "en": "Email",
            "fi": "Sähköposti",
            "sv": "E-post"
          },
          "value": "email"
        },
        {
          "label": {
            "en": "Phone",
            "fi": "Puhelin",
            "sv": "Telefon"
          },
          "value": "phone"
        },
        {
          "label": {
            "en": "SMS",
            "fi": "Tekstiviesti",
            "sv": "SMS"
          },
          "value": "sms",
          "disabled": true                             // Optional: Disable this option
        }
      ]
    }
  }
*/

@Component({
  selector: "app-radio",
  templateUrl: "./radio.type.html",
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RadioButtonModule, TranslocoDirective],
})
export class RadioComponent extends FieldType<FieldTypeConfig> implements OnInit {
  radioOptions: RadioOption[] = [];

  ngOnInit() {
    this.radioOptions = (this.props.options as RadioOption[]) || [];
  }

  public isDisabled(option: RadioOption): boolean {
    return this.formControl.disabled || !!option.disabled;
  }

  public isRequired(): boolean {
    return this.props.required || false;
  }

  public isInvalid(): boolean {
    return this.formControl.invalid && (this.formControl.dirty || this.formControl.touched);
  }
}
